import { makeAutoObservable, observable, action } from "mobx";
import { IStation } from "../models/IUser";
import StationOwnerService from "../services/StationOwnerService";
import $api from "../http";
import { logApiError } from "../utils/logApiError";

export class StationOwnerStore {
  stations: IStation[] = [];
  isLoading = false;
  error: string | null = null;
  private autoRefreshInterval: NodeJS.Timeout | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  setStations(stations: IStation[]) {
    this.stations = observable(stations);
  }

  @action
  setLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  @action
  setError(error: string | null) {
    this.error = error;
  }

  @action
  reset() {
    this.stations = [];
    this.isLoading = false;
    this.error = null;
    this.stopPolling();
  }

  @action
  startPolling(intervalMs = 5000) {
    this.stopPolling();
    this.autoRefreshInterval = setInterval(() => {
      this.pollMyStations();
    }, intervalMs);
  }

  @action
  stopPolling() {
    if (this.autoRefreshInterval) {
      clearInterval(this.autoRefreshInterval);
      this.autoRefreshInterval = null;
    }
  }

  async fetchMyStations() {
    this.setLoading(true);
    this.setError(null);
    try {
      const response = await StationOwnerService.getMyStations();
      this.setStations(response.data);
    } catch (error: any) {
      this.setError(error.message || "Не удалось загрузить станции");
    } finally {
      this.setLoading(false);
    }
  }

  async pollMyStations() {
    // Тихое обновление без лоадера
    try {
      const response = await StationOwnerService.getMyStations();
      this.setStations(response.data);
    } catch (error: any) {
      // Только логируем ошибку, не показываем UI
      logApiError("Poll error:", error);
    }
  }

  async restartStation(id: number, controller: number) {
    try {
      const response = await $api.post("/restart", { id, controller });
      return response.data;
    } catch (error: any) {
      const message =
        error.response?.data?.error ||
        error.message ||
        "Не удалось перезагрузить станцию";
      this.setError(message);
      throw new Error(message);
    }
  }
}

export const stationOwnerStore = new StationOwnerStore();
